import React, { useMemo } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme, type ThemeOptions } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import { useLanguage } from "../contexts/LanguageContext";
import { baseThemeOptions } from "./muiTheme";

const ltrCache = createCache({ key: "muiltr" });
const rtlCache = createCache({ key: "muirtl", stylisPlugins: [rtlPlugin] });

const DynamicMuiTheme: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isRTL } = useLanguage();

  const theme = useMemo(() => {
    const options: ThemeOptions = { ...baseThemeOptions, direction: isRTL ? "rtl" : "ltr" };
    return createTheme(options);
  }, [isRTL]);

  return (
    <CacheProvider value={isRTL ? rtlCache : ltrCache}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </CacheProvider>
  );
};

export default DynamicMuiTheme;
